import DataScienceVisual from 'bundles/enterprise-skillset-bank/components/SkillSetFinder/DataScienceVisual';
import FinanceVisual from 'bundles/enterprise-skillset-bank/components/SkillSetFinder/FinanceVisual';
import LeadershipVisual from 'bundles/enterprise-skillset-bank/components/SkillSetFinder/LeadershipVisual';
import MarketingVisual from 'bundles/enterprise-skillset-bank/components/SkillSetFinder/MarketingVisual';
import SoftwareEngineeringVisual from 'bundles/enterprise-skillset-bank/components/SkillSetFinder/SoftwareEngineeringVisual';

import _t from 'i18n!nls/enterprise-admin-skills';

export const getSkillSetAcademies = (enableDataTechSku?: boolean) => {
  const dataTechAcademies = [
    { id: 'data-science', name: _t('Data Science'), visual: DataScienceVisual },
    { id: 'tech', name: _t('Tech'), visual: SoftwareEngineeringVisual },
  ];
  const allAcademies = [
    ...dataTechAcademies,
    { id: 'finance', name: _t('Finance'), visual: FinanceVisual },
    { id: 'marketing', name: _t('Marketing'), visual: MarketingVisual },
    { id: 'leadership', name: _t('Leadership'), visual: LeadershipVisual },
  ];
  return enableDataTechSku ? dataTechAcademies : allAcademies;
};

export const getSkillSetAcademyIds = (enableDataTechSku?: boolean) =>
  getSkillSetAcademies(enableDataTechSku).map((_) => _.id);

export const isInBeta = (academyId: string) => ['finance'].includes(academyId);

/**
 * Since functionId is an optional field on the skillset resource and
 * the skillset finder relies on it to group skillsets by Department,
 * I'm an introducing this fallbackFunctionId as a fallback department.
 */
export const fallbackFunctionId = 'other';

export const dataTechAcademyIds = ['data-science', 'tech'];

export const matchDataTechAcademies = (academyIds: string[]) =>
  academyIds.some((academyId) => dataTechAcademyIds.includes(academyId));
